export default __webpack_public_path__ + "static/media/10.8c77b318.jpg";